var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPensativo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3826_30374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.11 73.1095C88.4254 59.7942 88.4254 38.2058 75.11 24.8905C61.7947 11.5752 40.2063 11.5752 26.891 24.8905C13.5757 38.2058 13.5757 59.7942 26.891 73.1095C40.2063 86.4248 61.7947 86.4248 75.11 73.1095Z",
    fill: "#FFD05D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8359 19.9C72.9895 26.4021 74.8153 34.1206 74.015 41.7945C73.2147 49.4684 69.8357 56.6441 64.4299 62.1492C59.0241 67.6544 51.9112 71.1636 44.2531 72.1035C36.595 73.0434 28.8446 71.3585 22.2679 67.324C25.0294 71.642 28.7289 75.2819 33.0911 77.9728C37.4534 80.6638 42.3662 82.3367 47.4642 82.867C52.5622 83.3974 57.7142 82.7715 62.537 81.0361C67.3597 79.3006 71.7291 76.5001 75.3203 72.843C78.9114 69.1859 81.6318 64.7662 83.2791 59.9126C84.9265 55.0591 85.4584 49.8965 84.8353 44.8091C84.2122 39.7216 82.4501 34.84 79.6801 30.5275C76.9101 26.2149 73.2035 22.5824 68.8359 19.9Z",
    fill: "#FDC453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5399 52.6C21.54 45.9888 23.6098 39.5436 27.4592 34.1686C31.3085 28.7936 36.744 24.7587 43.0031 22.63C49.2622 20.5013 56.0307 20.3856 62.3588 22.2992C68.687 24.2128 74.2572 28.0597 78.2879 33.3C76.1256 29.5448 73.2153 26.2735 69.7373 23.6888C66.2593 21.104 62.2876 19.2609 58.0684 18.2735C53.8491 17.2861 49.472 17.1754 45.2082 17.9484C40.9444 18.7213 36.8847 20.3615 33.2806 22.7672C29.6764 25.1729 26.6046 28.2929 24.2552 31.9341C21.9059 35.5752 20.3291 39.6599 19.6226 43.9352C18.9161 48.2105 19.0948 52.5853 20.1477 56.7887C21.2007 60.9922 23.1054 64.9346 25.7439 68.372C22.9829 63.5746 21.533 58.1351 21.5399 52.6Z",
    fill: "#FFD77F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.407 44.0312C44.0986 39.7703 41.2052 35.7555 36.9443 35.0639C32.6834 34.3722 28.6686 37.2657 27.9769 41.5266C27.2853 45.7874 30.1787 49.8023 34.4396 50.4939C38.7005 51.1855 42.7153 48.2921 43.407 44.0312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.172 37.2081C39.9498 36 38.3623 35.2303 36.6568 35.019C34.9514 34.8077 33.224 35.1668 31.744 36.0401C31.5099 36.3291 31.3628 36.6787 31.32 37.0481C31.168 38.6801 33.272 40.2121 36.02 40.4681C38.768 40.7241 41.12 39.6121 41.272 37.9801C41.2966 37.7185 41.2624 37.4548 41.172 37.2081Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8346 48.3014C74.887 45.2491 74.887 40.3003 71.8346 37.2479C68.7823 34.1956 63.8335 34.1956 60.7811 37.2479C57.7288 40.3002 57.7288 45.2491 60.7811 48.3014C63.8335 51.3537 68.7823 51.3537 71.8346 48.3014Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 37.2081C70.5763 35.9984 68.9866 35.2278 67.2789 35.0165C65.5713 34.8052 63.8417 35.1651 62.36 36.0401C62.1254 36.3283 61.9795 36.6785 61.94 37.0481C61.784 38.6801 63.888 40.2121 66.636 40.4681C69.384 40.7241 71.74 39.6121 71.892 37.9801C71.9152 37.7191 71.8839 37.4562 71.8 37.2081Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6879 56.812C61.887 55.1142 59.6604 53.9353 57.2439 53.4C54.8308 52.8319 52.3239 52.7869 49.8919 53.268C47.4761 53.7384 45.1797 54.6907 43.1399 56.068C41.1127 57.4016 39.4164 59.1801 38.1799 61.268C38.1096 61.3898 38.0726 61.5281 38.0728 61.6688C38.0729 61.8095 38.1101 61.9477 38.1807 62.0694C38.2513 62.1911 38.3528 62.292 38.4748 62.362C38.5969 62.432 38.7352 62.4686 38.8759 62.468C38.9978 62.4685 39.1182 62.4411 39.2279 62.388L39.9759 62.02C41.7319 61.148 43.3879 60.328 45.0719 59.672C46.9233 58.9257 48.8412 58.3565 50.7999 57.972C52.7458 57.5945 54.7262 57.4242 56.7079 57.464C58.8214 57.5197 60.9264 57.7553 62.9999 58.168C63.1683 58.1993 63.3422 58.1757 63.4962 58.1008C63.6501 58.0258 63.776 57.9035 63.8552 57.7517C63.9344 57.5999 63.9629 57.4267 63.9364 57.2576C63.9099 57.0884 63.8298 56.9322 63.7079 56.812H63.6879Z",
    fill: "#5E4939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3826_30374",
    x: 0.904541,
    y: 0.904053,
    width: 100.192,
    height: 100.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3826_30374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3826_30374",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensativo);
export default __webpack_public_path__ + "static/media/pensativo.1aafb1e9357de7ac9e7a1d8864b0cc83.svg";
export { ForwardRef as ReactComponent };